<ng-content select="frg-side-menu,[frg-side-menu]"></ng-content>
<div class="side-menu-content">
    <ng-content select="[frg-menu-content]"></ng-content>
</div>